// Pure rules for date-ranged allocations.
//
// An allocation is active on date D when effectiveDate <= D < endDate. Blank
// effective = active from the beginning; blank end = open-ended. The active set
// only changes at window boundaries, so it's enough to evaluate the total at each
// distinct window start.

import type { CustomerAllocation } from "../../lib/types";

const NEG_INF = "0000-00-00";
const POS_INF = "9999-99-99";

/**
 * The combined percentage active at each distinct allocation start date — one
 * number per active interval. A customer's allocations should total exactly 100%
 * on every active date, so the caller checks every entry equals 100.
 */
export function allocationIntervalTotals(allocations: CustomerAllocation[]): number[] {
  if (allocations.length === 0) return [];
  const startPoints = [...new Set(allocations.map((a) => a.effectiveDate || NEG_INF))];
  return startPoints.map((point) => {
    let total = 0;
    for (const a of allocations) {
      const start = a.effectiveDate || NEG_INF;
      const end = a.endDate || POS_INF;
      if (start <= point && point < end) total += a.percentage;
    }
    return total;
  });
}
